/**
 * contract's domain
 */
export default class Domain {
  constructor() {
    this.id = '';
    this.name = '';
    this.checked = false;
    this.is_ensemble = false;
    this.predicts = [];
    this.prioritet = '';
    this.predictRanges = [];
    this.parameterLayersViewModel = [];
    this.parameters = [];
    this.is_interpolate_point = false;
    this.is_interpolate_preset = false;
  }

  get fullName() {
    const ensemble = this.is_ensemble ? '[ensemble]' : '';
    return `${this.name} ${ensemble}`;
  }

  set checkedAll(val) {
    this.predicts.forEach(d => d.checked = val);
  }

  get checkedAll() {
    return !this.predicts.some(d => !d.checked);
  }

  uncheck() {
    this.predicts.forEach(x => x.checked = false);
    this.parameterLayersViewModel.forEach(x => x.checked = false);
    this.is_interpolate_point = false;
    this.is_interpolate_preset = false;
  }
}
